import { useRef, useState } from "react";
import { Dropdown, Icon } from "semantic-ui-react";
import {
  CardDotMenuItemComponent,
  CardDotMenuItemComponentProps,
} from "./CardDotMenuItemComponent";

export const CardDotMenuComponent = (props: {
  props: CardDotMenuComponentProps;
  cardData: any;
  setReloadKey: any;
  pageData: any;
  setPageData: any;
}) => {
  const dropdownRef = useRef<HTMLDivElement | null>(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  return (
    <div ref={dropdownRef as any} className="card-dot-menu">
      <Dropdown
        open={dropdownOpen}
        icon={null}
        trigger={
          <Icon
            name="ellipsis vertical"
            onClick={() => setDropdownOpen(!dropdownOpen)}
            style={{ cursor: "pointer" }}
          />
        }
        pointing="top right"
      >
        <Dropdown.Menu>
          {props.props.menuItems.map((item, index) => (
            <CardDotMenuItemComponent
              cardData={props.cardData}
              key={index}
              props={item}
              setReloadKey={props.setReloadKey}
              pageData={props.pageData}
              setPageData={props.setPageData}
            />
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export type CardDotMenuComponentProps = {
  menuItems: CardDotMenuItemComponentProps[];
};
